import * as React from 'react';
import { connect } from 'react-redux';

import { ActionMenu, EXTRA_SMALL_ICON_BASE_SRC, getParameterByName, SMALL_ICON_BASE_SRC, Tooltip } from '../../../Shared';
import {
  removeWatchTeacherState,
  setWatchTeacherState,
  showSignupModal,
  unpinActivityOnSaveAndExit
} from '../../actions/classroomSessions';
import {
  createNewEdition
} from '../../actions/customize';
import {
  ClassroomUnitId
} from '../classroomLessons/interfaces';

const MOBILE_BREAKPOINT = 480

const flagIcon = `${SMALL_ICON_BASE_SRC}/flag.svg`
const watchTeacherIcon = `${SMALL_ICON_BASE_SRC}/account-wave.svg`
const projectorIcon = `${SMALL_ICON_BASE_SRC}/play-display.svg`
const pdfIcon = `${SMALL_ICON_BASE_SRC}/download-document.svg`
const checkCircleIcon = `${EXTRA_SMALL_ICON_BASE_SRC}/check-color.svg`

const HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }
const escapeHtml = (str: string) => String(str).replace(/[&<>"']/g, (char) => HTML_ESCAPES[char])

class TeacherNavbar extends React.Component<any, any> {
  constructor(props) {
    super(props);

    const classroomUnitId: ClassroomUnitId|null = getParameterByName('classroom_unit_id')
    const activityUid = props.match.params.lessonID

    this.state = {
      showMenuDropdown: false,
      isMobile: window.innerWidth <= MOBILE_BREAKPOINT,
      classroomUnitId,
      classroomSessionId: classroomUnitId ? classroomUnitId.concat(activityUid) : null
    }

    this.presentStudentCount = this.presentStudentCount.bind(this)
    this.redirectToEdit = this.redirectToEdit.bind(this)
    this.redirectToSwitchEdition = this.redirectToSwitchEdition.bind(this)
    this.handleExitLessonClick = this.handleExitLessonClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
  }

  renderCustomizedEditionsTag() {
    const { customize, classroomSessions, } = this.props
    const { editions, } = customize
    const editionId = classroomSessions.data.edition_id
    const currentEdition = editionId ? editions[editionId] : undefined

    if (currentEdition && String(currentEdition.user_id) !== 'quill-staff') {
      return (<div className="custom-editions-tag">Customized</div>)
    }
  }

  presentStudentCount() {
    const { classroomSessions, } = this.props
    const { presence } = classroomSessions.data
    const numPresent = presence === undefined ? 0 : Object.keys(presence).filter((id) => presence[id] === true ).length
    return (
      <p className="present-student-count">
        {numPresent > 0 && <img alt="" className="status-indicator" height={16} src={checkCircleIcon} width={16} />}
        <span>{numPresent} Student{numPresent === 1 ? '' : 's'} Online</span>
      </p>
    )
  }

  handleMenuDropdownToggle = () => {
    this.setState(prevState => ({showMenuDropdown: !prevState.showMenuDropdown}));
  }

  handleProjectorClick = () => window.open(window.location.href.replace('teach', 'play').concat('&projector=true'), 'newwindow', `width=${window.innerWidth},height=${window.innerHeight}`)

  renderPDFLink() {
    const { classroomSessions, match } = this.props
    const { params } = match

    if (classroomSessions.data.supportingInfo) {
      return (
        <a
          aria-label="Download PDF with supporting info"
          className="focus-on-dark toolbar-tooltip-trigger toolbar-icon"
          href={`${window.postbuildEnv.DEFAULT_URL}/activities/${params.lessonID}/supporting_info`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Tooltip
            isTabbable={false}
            mode="dark"
            tooltipText="Download Lesson Plan"
            tooltipTriggerText={<img alt="" height={24} src={pdfIcon} width={24} />}
          />
        </a>
      )
    }
  }

  getHelpActions() {
    return [
      {
        element: (
          <a
            className="action focus-on-light"
            href={`${window.postbuildEnv.DEFAULT_URL}/tutorials/lessons?nocta=true`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Tutorial
          </a>
        )
      },
      {
        element: (
          <a
            className="action focus-on-light"
            href="https://support.quill.org/using-quill-tools#quill-lessons"
            rel="noopener noreferrer"
            target="_blank"
          >
            Q&amp;A
          </a>
        )
      }
    ]
  }

  getEditAction() {
    const { customize, match, classroomSessions, dispatch } = this.props
    const { params } = match
    const classroomUnitId = getParameterByName('classroom_unit_id')

    if (customize.user_id && classroomUnitId) {
      const lessonID: string = params.lessonID
      const editionID: string = classroomSessions.data.edition_id
      if (editionID && customize.editions[editionID] && customize.editions[editionID].user_id === customize.user_id) {
        return {
          name: 'Edit This Edition',
          action: () => { this.redirectToEdit(lessonID, editionID, classroomUnitId) }
        }
      } else {
        return {
          name: 'Make A Copy',
          action: () => {
            createNewEdition(
              editionID,
              lessonID,
              customize.user_id,
              classroomUnitId,
              this.redirectToEdit
            )
          }
        }
      }
    }
    return {
      name: 'Make A Copy',
      action: () => dispatch(showSignupModal())
    }
  }

  handleSwitchEditionClick = () => {
    const { customize, match, dispatch } = this.props
    const { params } = match

    if (customize.user_id) {
      const lessonID: string = params.lessonID
      const classroomUnitId = getParameterByName('classroom_unit_id')
      if (classroomUnitId) {
        this.redirectToSwitchEdition(lessonID, classroomUnitId)
      }
    } else {
      dispatch(showSignupModal())
    }
  }

  redirectToEdit(lessonID:string, editionID:string, classroomUnitId:string) {
    const { match, } = this.props
    const { params, } = match
    window.location.href = `#/customize/${params.lessonID}/${editionID}?&classroom_unit_id=${classroomUnitId}`
  }

  redirectToSwitchEdition(lessonID:string, classroomUnitId:string) {
    window.location.href =`#/customize/${lessonID}?&classroom_unit_id=${classroomUnitId}`
  }

  getCustomizeActions() {
    return [
      this.getEditAction(),
      {
        name: 'Switch Edition',
        action: this.handleSwitchEditionClick
      }
    ]
  }

  getMobileToolbarActions() {
    const { classroomSessions, match, } = this.props
    const { watchTeacherState, supportingInfo, } = classroomSessions.data

    const actions: Array<any> = [
      { name: watchTeacherState ? 'Turn Off Watch Teacher' : 'Watch Teacher', action: this.handleWatchTeacherClick },
      { name: 'Launch Projector', action: this.handleProjectorClick },
    ]

    if (supportingInfo) {
      actions.push({
        element: (
          <a
            className="action focus-on-light"
            href={`${window.postbuildEnv.DEFAULT_URL}/activities/${match.params.lessonID}/supporting_info`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Download Lesson Plan
          </a>
        )
      })
    }

    return actions
  }

  getMenuActions() {
    const actions = [...this.getCustomizeActions(), ...this.getHelpActions()]

    if (this.state.isMobile) {
      return [...actions, ...this.getMobileToolbarActions()]
    }

    return actions
  }

  flagTooltipText() {
    const { classroomSessions, } = this.props
    const { flaggedStudents, students } = classroomSessions.data
    const flaggedStudentIds = flaggedStudents ? Object.keys(flaggedStudents) : []

    if (flaggedStudentIds.length) {
      return flaggedStudentIds.map((studentId) => escapeHtml(students[studentId]))
    }

    return '<span class="flag-tooltip-header">No Flagged Students</span><span class="flag-tooltip-body">Flag students based on their performance for small group instruction.</span>'
  }

  handleExitLessonClick = () => {
    const { match, } = this.props
    const { params, } = match
    const classroomUnitId = getParameterByName('classroom_unit_id') || '';
    const shouldExit = window.confirm('Are you sure you want to exit the lesson?')

    if (shouldExit) {
      unpinActivityOnSaveAndExit(params.lessonID, classroomUnitId)
      document.location.href = window.postbuildEnv.DEFAULT_URL || 'https://www.quill.org';
    }
  }

  handleWatchTeacherClick = () => {
    const { classroomSessionId, } = this.state
    const { classroomSessions, } = this.props
    const { watchTeacherState } = classroomSessions.data

    if (watchTeacherState) {
      if (classroomSessionId) {
        removeWatchTeacherState(classroomSessionId);
      }
    } else {
      setWatchTeacherState(classroomSessionId);
    }
  }

  previewBar() {
    const { classroomSessions, } = this.props
    const { preview } = classroomSessions.data
    if (preview === true) {
      const assignLink = `${window.postbuildEnv.DEFAULT_URL}/assign/activity-library?activityClassificationFilters[]=lessons`
      const studentLink = window.location.href.replace('teach', 'play').concat('&student=student')
      /* eslint-disable react/jsx-no-target-blank */
      return (
        <div className="lessons-teacher-preview-bar">
          <p>You are previewing the teacher&#39;s view of Quill Lessons. <a href={assignLink} target="_blank">Assign Quill Lessons</a> from your dashboard.</p>
          <a className="student-link focus-on-light" href={studentLink} target="_blank">Open Student View</a>
        </div>
      )
      /* eslint-enable react/jsx-no-target-blank */
    }
  }

  renderWatchTeacherTooltip() {
    const { classroomSessions, } = this.props
    const { watchTeacherState } = classroomSessions.data
    const tooltipText = watchTeacherState ? "Watch Teacher - On" : "Watch Teacher - Off"

    return (
      <Tooltip
        isTabbable={false}
        mode="dark"
        tooltipText={tooltipText}
        tooltipTriggerText={<img alt="" height={24} src={watchTeacherIcon} width={24} />}
      />
    )
  }

  render() {
    const { showMenuDropdown, } = this.state
    const { classroomLesson, } = this.props
    const quillLogoSrc = `${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-white.svg`

    return (
      <div>
        {this.previewBar()}
        <nav aria-label="Teacher Navigation" className="lessons-teacher-navbar">
          <div className="navbar-left">
            <a aria-label="Quill" className="navbar-logo focus-on-dark" href={window.postbuildEnv.DEFAULT_URL}>
              <img alt="Quill logo" src={quillLogoSrc} />
            </a>
            <span className="tool-name">Lessons</span>
            <span aria-hidden="true" className="navbar-vertical-divider" />
            <header className="lesson-title">
              <h2>
                <span>Lesson {classroomLesson.data.lesson}:</span> {classroomLesson.data.title}
              </h2>
              {this.renderCustomizedEditionsTag()}
            </header>
          </div>
          <div
            aria-label="Teacher Actions Toolbar"
            className="toolbar"
            role="toolbar"
          >
            {this.presentStudentCount()}
            <div className="icons">
              <div className="toolbar-icon flag-tooltip-container">
                <Tooltip
                  isTabbable
                  mode="dark"
                  tooltipText={this.flagTooltipText()}
                  tooltipTriggerText={<img alt="Flagged students" height={24} src={flagIcon} width={24} />}
                />
              </div>
              <button
                aria-label="Toggle Watch Teacher mode"
                className="interactive-wrapper focus-on-dark toolbar-icon toolbar-tooltip-trigger"
                onClick={this.handleWatchTeacherClick}
                type="button"
              >
                {this.renderWatchTeacherTooltip()}
              </button>
              <button
                aria-label="Launch projector"
                className="interactive-wrapper focus-on-dark toolbar-icon toolbar-tooltip-trigger"
                onClick={this.handleProjectorClick}
                type="button"
              >
                <Tooltip
                  isTabbable={false}
                  mode="dark"
                  tooltipText="Launch Projector"
                  tooltipTriggerText={<img alt="" height={24} src={projectorIcon} width={24} />}
                />
              </button>
              {this.renderPDFLink()}
            </div>
            <div className="navbar-buttons">
              <div className="actions-menu-container header-menu">
                <ActionMenu
                  actions={this.getMenuActions()}
                  buttonAriaLabel="Menu"
                  isOpen={showMenuDropdown}
                  onToggle={this.handleMenuDropdownToggle}
                  triggerElement={<button className="navbar-menu-button focus-on-dark" type="button">Menu<i className="fa fa-chevron-down" /></button>}
                />
              </div>
              <button
                className="navbar-save-exit-button focus-on-dark"
                onClick={this.handleExitLessonClick}
                type="button"
              >
                Save and Exit
              </button>
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

function select(props) {
  return {
    classroomLesson: props.classroomLesson,
    classroomSessions: props.classroomSessions,
    customize: props.customize,
  }
}

function mergeProps(stateProps: Object, dispatchProps: Object, ownProps: Object) {
  return { ...ownProps, ...stateProps, ...dispatchProps }
}

export default connect(select, (dispatch) => ({ dispatch }), mergeProps)(TeacherNavbar)
